import React from 'react';

const EyeIcon = ({ off }) => (
  <svg width="18" height="18" viewBox="0 0 24 24" fill="none">
    {off ? (
      <path
        d="M3 3l18 18M10.6 10.6a2.5 2.5 0 003.4 3.4M6.3 6.4C4 8 2.4 10.3 2 12c1.4 4.5 5.7 7.5 10 7.5 1.6 0 3.2-.4 4.6-1.1M9.9 4.7A10.6 10.6 0 0112 4.5c4.3 0 8.6 3 10 7.5a12.6 12.6 0 01-2.6 4.4"
        stroke="currentColor" strokeWidth="1.6" strokeLinecap="round" strokeLinejoin="round"
      />
    ) : (
      <>
        <path d="M2 12c1.4-4.5 5.7-7.5 10-7.5s8.6 3 10 7.5c-1.4 4.5-5.7 7.5-10 7.5S3.4 16.5 2 12z" stroke="currentColor" strokeWidth="1.6" strokeLinejoin="round" />
        <circle cx="12" cy="12" r="2.7" stroke="currentColor" strokeWidth="1.6" />
      </>
    )}
  </svg>
);

export default EyeIcon;
